export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  SECONDARY_BLUE = 'SECONDARY_BLUE',
  SECONDARY_RED = 'SECONDARY_RED',
  SECONDARY_BLACK = 'SECONDARY_BLACK',
  SECONDARY_NO_OUTLINE = 'SECONDARY_NO_OUTLINE',
  LINK = 'LINK',
  BLACK = 'BLACK',
  ICON_ONLY = 'ICON_ONLY',
  DANGER = 'DANGER',
}

export enum ButtonSize {
  SMALL = 'SMALL',
  DEFAULT = 'DEFAULT',
  MEDIUM = 'MEDIUM',
}
